const formatFacultad = (value) => {
  const facultades = {
    facultad_de_ciencias_exactas_y_naturales: "Facultad de Ciencias Exactas y Naturales",
    presencial: "Presencial",
    hibrida: "Híbrida",
  };

  return facultades[value] || value;
};

const Facultad = ({ value }) => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null;
  }

  const facultades = (Array.isArray(value) ? value : [value])
    .filter(Boolean)
    .map(formatFacultad);

  return <>{facultades.join(" / ")}</>;
};

export default Facultad;